import { MobileShell as SharedMobileShell } from "@shared/components/MobileShell";
import { DataUseAcknowledgmentModal } from "@shared/components/DataUseAcknowledgmentModal";
import { BottomTabBar } from "../components/BottomTabBar";
import { WalkthroughProvider } from "../walkthrough/WalkthroughContext";
import { WalkthroughOverlay } from "../walkthrough/WalkthroughOverlay";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Home",
  "/messages": "Messages",
  "/billing": "Billing",
  "/me": "Profile",
  "/incidents": "Incident Reports",
};

export function MobileShell() {
  return (
    <WalkthroughProvider>
      <SharedMobileShell
        routeTitles={ROUTE_TITLES}
        tabBar={(unreadCount) => <BottomTabBar unreadCount={unreadCount} />}
      >
        <WalkthroughOverlay />
        <DataUseAcknowledgmentModal />
      </SharedMobileShell>
    </WalkthroughProvider>
  );
}
